export const installedToast = {
  title: 'この追跡ツールはすでにインストールされています',
  description: '他の追跡ツールを追加するか、この追跡ツールを編集してください',
};
